// @ts-nocheck
import * as React from "react";
import "./App.css";
import Product from "./Components/Product/product";
import {connect} from "react-redux";
import MainHeader from "./Components/MainHeader/mainHeader";
import {authenticateSession, selectProduct, updateAuthCode, updateAuthFlag, updateSessionId} from "./ducks";
import {DOMAIN_TYPE, REPORTING_URL} from "./constants";
import {encryptSession, validateSession} from "./utils";
import axios from "axios";
import Page404 from "./Pages/page404";

class App extends React.Component<any, any> {
    public readonly state = {
        error: false
    };
    public componentDidMount = () => {
        if (DOMAIN_TYPE === "americanexpress") {
            const urlParams = new URLSearchParams(window.location.search);
            const myCode = urlParams.get("invite");
            urlParams.delete("invite");
            const {updateAuthFlag, authenticateSession, updateAuthCode} = this.props;
            if (myCode) {
                axios({
                    method: "GET",
                    url: `${REPORTING_URL}/accessControl/${myCode}`,
                    timeout: 6000,
                }).then((response: any) => {
                    const {data} = response;
                    if (data && data.status) {
                        const {code} = data.status;
                        if (code === "0000") {
                            updateAuthFlag(true);
                            updateAuthCode(myCode);
                            let sessionId = myCode;
                            this.props.updateSessionId(sessionId);
                            encryptSession(sessionId);
                            this.props.history.push({
                                pathname: "/",
                                search: urlParams.toString(),
                            });
                        } else {
                            throw "Error";
                        }
                    } else {
                        throw "Error";
                    }
                }).catch(err => {
                    updateAuthFlag(false);
                    window.sessionStorage.clear();
                    this.props.history.push({
                        pathname: "/404",
                        search: urlParams.toString(),
                    });
                });
            } else {
                if (!validateSession()) {
                    // this.props.history.push({
                    //     pathname: "/404",
                    //     search: urlParams.toString(),
                    // });
                    this.setState({error: true});
                } else {
                    updateAuthFlag(true);
                }
            }
        } else {
            this.props.updateAuthFlag(true);
        }
    };

    public checkout = (data) => {
        this.props.setProduct(data);
        window.location.href = "/checkout";
    };

    public skAuth = (data) => {
        this.props.setProduct(data);
        window.location.href = "/srcsafekeyservices";
    };


    public config = () => {
        this.props.history.push({
            pathname: "/configuration",
        });
    };

    public render() {
        const {history, authenticated} = this.props;
        let shoppingItems = this.props.products;
        if (this.state.error) {
            return <Page404/>;
        }

        return (
            <div>
                {authenticated ?
                    <>
                        <MainHeader history={history}/>
                        <div className="App" style={{padding: "5em"}}>
                            <div className="row">
                                {shoppingItems && shoppingItems.map((item, index) => {
                                    return <Product
                                        key={index}
                                        name={item.productName}
                                        price={item.price}
                                        image={item.image}
                                        onClick={this.checkout}
                                    />;
                                })}
                            {/* <p onClick={this.skAuth}>Route to skAuth Book Now </p> */}
                            <button
                                onClick={this.skAuth}
                                style={{
                                    backgroundColor: '#006fcf',
                                    color: 'white',
                                    padding: '1em, 2em',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    width: '100%',
                                    maxWidth: '300px',
                                    display: 'block',
                                    margin: '10px auto',
                                    textAlign: 'center',
                                    height: '50px',
                                    fontSize: '18px',
                                    marginTop: '91px'
                                }}
                                >
                                Route to skAuth Book Now
                                </button>

                            </div>
                            <div className={"settings-div"} onClick={this.config}>
                                <span className="icon icon-lg icon-hover dls-icon-setting dls-gray-05"/>
                            </div>
                        </div>
                    </>
                    :
                    <div className="centred-div">
                        <div className="stage">
                            <h1 className="header-1 pad-3-r">Attempting to log you in</h1>
                            <div className="dot-flashing"/>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default connect((state) => (state),
    (dispatch: any) => ({
        setProduct: (product: any) =>
            dispatch(selectProduct(product)),
        updateAuthCode: (code: any) =>
            dispatch(updateAuthCode(code)),
        updateAuthFlag: (flag: any) =>
            dispatch(updateAuthFlag(flag)),
        updateSessionId: (code: any) =>
            dispatch(updateSessionId(code)),
        authenticateSession: (code: any) =>
            dispatch(authenticateSession(code)),
    }))(App);

